<template>
    <label class="border-btn-radio">
        {{checkboxMsg}}
        <input type="radio" :value="val" v-model="checked" @change="onChange" />
    </label>
</template>
<script>
export default {
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
        }
    },
    props: {
        checkboxMsg: String,
        val: '',
        value: '',
        isPropChecked: {
            default: true,
            type: Boolean
        },
        setDefault: Boolean
    },
    watch: {
        isPropChecked: function (val) {
            this.isChecked = val
        },
        setDefault: function () {

        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = true;
            this.$emit('input', this.checkVal)
        }
    }
}
</script>
<style   lang="scss">
    .border-btn-radio{
        border-radius: 4px;
        border: solid 1px #e0dfde;
        width: 208px;
        height: 44px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        color: #676362;
        cursor: pointer;
        font-weight: 300;
        box-sizing: border-box;
        input{
            display: none;
        }
        &.active{
            border: solid 1px #ff9275;
            color: #ff9275;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/borderBtnRadio.vue